import { render, staticRenderFns } from "./EditChartAnnotations.vue?vue&type=template&id=7c57996b"
import script from "./EditChartAnnotations.vue?vue&type=script&lang=js"
export * from "./EditChartAnnotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports